<template>
    <auction-dialog title="경매 호가표 안내" @open="init">
        <template #activator="{attrs,on}">
            <slot name="activator" v-bind="{ attrs, on }" />
        </template>
        <template #default>
            <v-data-table :headers="headers" :items="items" hide-default-footer disable-sort :items-per-page="-1" class="v-data-table--default">
                <template v-for="header in headers.filter((header) => header.hasOwnProperty('formatter'))" v-slot:[`item.${header.value}`]="{ value }">{{ header.formatter(value) }}</template>
            </v-data-table>
        </template>
    </auction-dialog>
</template>

<script>
import { BID_UNIT_POLICIES as items } from "@/assets/variables";
import AuctionDialog from "./auction-dialog.vue";

const headers = [
    { align: "center", text: "현재가 구간 (원)", value: "text", divider: true },
    { align: "center", text: "호가 단위 (원)", value: "value", formatter: (value) => (value / 10000).format() + "만원" },
];

export default {
    components: { AuctionDialog },
    props: {
        work: { type: Object, default: () => ({}) },
    },
    data: () => ({
        items,
        headers,
    }),
    methods: {
        async init() {
            // do something
        },
    },
};
</script>

<style></style>
